import { Box } from '@mui/material';

/**
 * A button displayed only in development that matches the CookieYes Cookie Consent button
 * Useful for checking layout conflicts with other elements on the page
 */
export function DevCookieBtn() {
  if (process.env.REACT_APP_AWS_BRANCH === 'master') {
    return null;
  } else {
    return (
      <Box
        data-cky-tag="revisit-consent"
        data-tooltip="Consent Preferences"
        sx={{
          WebkitFontSmoothing: 'antialiased',
          textSizeAdjust: '100%',
          color: 'rgb(255, 255, 255)',
          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
          fontWeight: 400,
          fontSize: '1rem',
          lineHeight: 1.5,
          letterSpacing: '0.00938em',
          boxSizing: 'inherit',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#0056a7',
          width: '45px',
          height: '45px',
          borderRadius: '50%',
          position: 'fixed',
          zIndex: 999999,
          cursor: 'pointer',
          bottom: '15px',
          left: '15px',
        }}
        style={{ backgroundColor: '#0056a7' }}
      >
        <Box
          component="button"
          aria-label="Consent Preferences"
          sx={{
            WebkitFontSmoothing: 'antialiased',
            textSizeAdjust: '100%',
            boxSizing: 'inherit',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 'none',
            cursor: 'pointer',
            position: 'relative',
            margin: 0,
            padding: 0,
            background: 'transparent',
          }}
        >
          <Box
            component="img"
            alt="Revisit consent button"
            src="https://cdn-cookieyes.com/assets/images/revisit.svg"
            sx={{
              WebkitFontSmoothing: 'antialiased',
              textSizeAdjust: '100%',
              cursor: 'pointer',
              boxSizing: 'inherit',
              maxWidth: 'fit-content',
              margin: 0,
              height: '30px',
              width: '30px',
            }}
          />
        </Box>
      </Box>
    );
  }
}
